<template>
  <span class="loader" v-bind:class="{ fullPage: this.type === 'fullPage' }">
    <transition name="fade">
      <Icon v-if="visible" :width="width" icon="circleNotch" />
    </transition>
  </span>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'LoadingComponent',
  components: {
    Icon,
  },
  props: {
    size: { default: 'medium' },
    type: { default: 'inline' },
    visible: { default: true },
  },
  computed: {
    width() {
      if (this.size === 'medium') {
        return '16px';
      }
      if (this.size === 'large') {
        return '32px';
      }
      return '16px';
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  display: inline-block;
}
.fullPage {
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
}
</style>
